import React from "react";
import { Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import usePageTexts from "@/hooks/usePageTexts";

const LOGO_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_arena-dubal/artifacts/dgj3odz1_Logo%20Dubal%20branca.png";

export default function LoginPage() {
  const { user, checking, loginWithGoogle } = useAuth();
  const t = usePageTexts();

  if (!checking && user) return <Navigate to="/" replace />;

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#0b1610] px-5">
      <div className="absolute inset-0 bg-gradient-to-br from-[#0b1610] via-[#123021] to-[#0b1610]" />
      <div className="relative w-full max-w-sm text-center">
        <img src={LOGO_URL} alt="Dubal Esportes" className="animate-float mx-auto w-56" />
        <h1 data-testid="login-title" className="mt-6 font-display text-2xl font-black text-white">{t("login_title")}</h1>
        <p className="mt-2 text-sm text-emerald-100/70">
          {t("login_subtitle")}
        </p>
        <Button
          data-testid="google-login-btn"
          onClick={loginWithGoogle}
          className="mt-8 w-full rounded-full bg-white py-6 text-base font-semibold text-slate-800 shadow-lg transition hover:scale-[1.02] hover:bg-slate-50"
        >
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="mr-3 h-5 w-5" />
          Entrar com o Google
        </Button>
        <p className="mt-6 text-xs text-emerald-100/50">
          {t("login_note")}
        </p>
      </div>
    </div>
  );
}
